import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Reviews() {
  const {
    t
  } = useLanguage();
  return <section id="reviews" className="py-24 bg-white" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-229">
            {t.reviews.title}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-230" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-231">
          {t.reviews.items.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-sand-light p-8 rounded-2xl" data-id="element-232">
              <div className="flex gap-1 mb-4" data-id="element-233">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-234" />)}
              </div>
              <p className="text-lg text-gray-700 italic" data-id="element-235">"{review}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}